<!--
Author: TangChen
Date: 2018-09-25
Desc: 修改密码页面组件
 -->
<template>
    <div class="comp-change-num comp">
        <nav-tips v-if="!fn" :data="titTips" />
        <div class="con">
            <set-pwd :pwd-con="pwdSet" v-on:pwd-get="pwdOk" />
        </div>
    </div>
</template>
<script>
import setPwd from "@/components/layout/setPwd.vue";
import navTips from "@/components/form/navTips.vue";
export default {
    name: "ChangeNum",
    components: {
        setPwd,
        navTips
    },
    props: {
        way: {
            type: String,
            default: "trade"
        },
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            pwdSet: {
                oldpwd: true,
                btn1: "确认修改",
                text: "登录",
                btnLock: false
            },
            titTips: {
                tit: "修改登录密码",
                text: "登录密码可用于快速登录网站/网上交易/APP/微信",
                cla: "login-pwd"
            },
            isTrade: false
        };
    },
    created () {
        this.isTrade = this.way === "trade";
        if (this.way === "query") {
            this.pwdSet.text = "查询";
            this.titTips = {
                tit: "修改查询密码",
                text: "查询密码可用于快速登录网站/网上交易/APP/微信",
                cla: "login-pwd"
            };
        }
        if (this.isTrade) {
            this.pwdSet.text = "交易";
            this.titTips = {
                tit: "修改交易密码",
                text: "交易密码用于下单等关键交易操作的安全验证",
                cla: "trade-pwd"
            };
        }
    },
    methods: {
    /* 提交表单数据 */
        pwdOk (action, val) {
            if (!action) {
                this.$router.back();
            } else {
                this.changePwd(val);
            }
        },
        // 修改密码
        changePwd (val) {
            const _this = this;
            let url = this.isTrade ? "acct/modpwd/trade" : "acct/modpwd/login";
            /* if (!this.isTrade && this.$cache.getUser().usertype === "2") {
                url = "acct/modpwd/cc";
            } */
            if (this.way === "query") {
                url = "acct/modpwd/cc";
            }
            this.$util.request(url, {
                oldpwd: this.$util.enc(val.old),
                newpwd: this.$util.enc(val.pwd)
            }, "POST").then(res => {
                if (res.data) {
                    /* const info = _this.$cache.getUser();
                    info.tradepwdexpired = "0";
                    _this.$store.dispatch("setInfo", info).then(() => {
                        _this.$message({
                            type: "success",
                            message: this.pwdSet.text + "密码修改成功" + (_this.fn ? "" : "，3秒后回到安全中心"),
                            onClose: function () {
                                if (_this.fn) { _this.$emit("fn-back", true); } else {
                                    _this.$router.back();
                                }
                            }
                        });
                    }); */
                    // 交易密码返回交易页面
                    if (this.way === "trade") {
                        _this.$cache.refreshUser();
                        _this.$message({
                            type: "success",
                            message: this.pwdSet.text + "密码修改成功,3秒后将回到首页",
                            onClose: function () {
                                _this.$router.replace("/home");
                            }
                        });
                    }else {
                        _this.$message({
                            type: "success",
                            message: this.pwdSet.text + "密码修改成功,3秒后将回到登录页重新登录",
                            onClose: function () {
                                _this.$util.request("common/logout", {}, false, false).then(res => {
                                    if (res.data) {
                                        _this.$store.dispatch("logout", res.data[0]).then(() => {
                                            _this.$router.replace("/");
                                        });
                                    }
                                });
                            }
                        });
                    }
                } else {
                    this.pwdSet.btnLock = false;
                    this.$message.warning(res.msg);
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.comp-change-num {
  padding-bottom: 30px;
  .con {
    padding: 20px;
    .comp-set-num {
      padding-bottom: 30px;
    }
  }
}
</style>
